import { RegistrationService } from 'services/main/endpoints/RegistrationService';
import { createToast, createErrorToast } from './createToast';
import { saveToOutbox, processOutbox } from './outbox';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const uploadDocument = async ({ file, filePath, token }) => {
  const response = await RegistrationService.uploadSignature({ filePath, file, token });

  if (response.status === 401) {
    throw new Error('Token inválido');
  }

  return response;
};

const handleDocUpload = async (imageData, token, setToastList, empresaId, cookie) => {
  if (!imageData || typeof imageData === 'string') {
    return imageData;
  }

  const file = imageData.file;

  if (file.size > MAX_FILE_SIZE) {
    createErrorToast(setToastList, `O arquivo excede o tamanho máximo permitido de 10MB.`);
    throw new Error('O arquivo excede o tamanho máximo permitido de 10MB.');
  }

  const loadingToast = createToast({
    type: 'loading',
    message: 'Estamos criando o documento...',
  });

  setToastList(prev => [...prev, loadingToast]);

  try {
    const response = await uploadDocument({
      file,
      filePath: imageData.cloudPath,
      token,
    });
    return response;
  } catch (error) {
    await saveToOutbox({
      file,
      filePath: imageData.cloudPath,
      empresaId,
      type: 'document',
    });
    processOutbox(cookie, setToastList);
    createErrorToast(setToastList, 'Erro ao enviar o documento. Vamos tentar novamente em segundo plano.');
    return null;
  } finally {
    setToastList(prev => prev.filter(t => t.id !== loadingToast.id));
  }
};

export { handleDocUpload };
